import Index from "./Index.jsx";

const DASHBOARD = {
  INDEX: Index,
};

export default DASHBOARD;